import type { DealerSegmentRow } from 'app/pages/DealerSegmentSettingsComponent/components/DealerSegmentModal';

/** Combined unique key: field_name + field_value + priority */
export function buildSegmentComboKey(
  segment: Pick<DealerSegmentRow, 'field_name' | 'field_value' | 'priority'>,
): string {
  const fieldName = String(segment.field_name ?? '').trim().toLowerCase();
  const fieldValue = String(segment.field_value ?? '').trim().toLowerCase();
  const priority = Number(segment.priority) || 1;
  return `${fieldName}\0${fieldValue}\0${priority}`;
}

export function isSegmentComboComplete(
  segment: Pick<DealerSegmentRow, 'field_name' | 'field_value' | 'priority'>,
): boolean {
  return (
    Boolean(String(segment.field_name ?? '').trim()) &&
    Boolean(String(segment.field_value ?? '').trim()) &&
    Number.isFinite(Number(segment.priority))
  );
}

/** O(n) once — build a Set for O(1) duplicate checks while typing. */
export function buildExistingSegmentComboKeys(
  segments: DealerSegmentRow[],
  excludeIndex = -1,
): Set<string> {
  const keys = new Set<string>();
  for (let i = 0; i < segments.length; i += 1) {
    if (i === excludeIndex) continue;
    const row = segments[i];
    if (!isSegmentComboComplete(row)) continue;
    keys.add(buildSegmentComboKey(row));
  }
  return keys;
}
